import {fetchGet} from "@/libs/reqCommon"
import {platformtoarr } from "@/libs/index";
import {platformChineseFun} from '@/libs/filterall';

// 获取违规数量最多的平台
const getMaxPlat = (arr) => {
	let max = {
		plateName:'~',
		maxCount:0
	}
	if(arr.length>0){
		max = {
			plateName:platformtoarr(arr[0].platformCode.split(','))[0].name,
			maxCount:Number(arr[0].platformTotalCount)
		}
		for(let i = 0; i<arr.length;i++){
			if(arr[i]){
				let count = Number(arr[i].platformTotalCount)
				if(count>max.maxCount){
					max.maxCount = count
					max.plateName = platformtoarr(arr[i].platformCode.split(','))[0].name
				}
			}
		}
	}
	return max;
}

const state = {
	serviceStep:{
		step:0,
		stepText:'第一步'
	},
	reportQuery:{},
  userinfo:{},
  serviceReportData:{},
  serviceLowpriceChart: [],
  serviceLowpriceList:{
	  content:[]
  },
  serviceLowpriceCount:{},
  serviceChart:{},
  informreport:null,
  CInventoryData:{
	platformMap:{}
  },
  IPRCompliantData:{},
  reportcheckCookCooks:[],
}

const getters = {
	// 违规检索
	serviceLowpriceChartData:state=>{

		let shoptypeWhite = [],shoptypeGrey = [],shoptypeBlack = [];
		let xData = new Set();
		for(let item of state.serviceLowpriceChart){
			if(item){
				xData.add(platformtoarr(item.platformCode.split(','))[0].name);
				shoptypeWhite.push(item.whiteCount?Number(item.whiteCount):0)
				shoptypeGrey.push(item.grayCount?Number(item.grayCount):0)
				shoptypeBlack.push(item.blackCount?Number(item.blackCount):0)
			}
		}
		let seriesData = {
			legend:['授权','灰名单','黑名单'],
			xData:[...xData],
			data:[{
				name:'授权',
				data:shoptypeWhite
			},{
				name:'灰名单',
				data:shoptypeGrey
			},{
				name:'黑名单',
				data:shoptypeBlack
			}]
		}
		return seriesData;
	},
	// 渠道信息盘点
	CInventoryData:state=>{
		let platformMap = state.CInventoryData.platformMap || {};
		let legend=[];
		let seriesData=[]
		for(let key in platformMap){
			legend.push(platformChineseFun(key))
			seriesData.push({
				name:platformChineseFun(key),
				value:platformMap[key].length
			})
		}
		let arr = [{
			name:"渠道信息管理",
			text:'收录店铺档案',
			total:state.CInventoryData.countMonth,
			authCount:state.CInventoryData.authorizecountMonth,
			greyCount:state.CInventoryData.greycountMonth,
			blackCount:state.CInventoryData.blackcountMonth,
			dealerCount:state.CInventoryData.dealercount,
			legend,
			seriesData
		}]
		return arr
	},
	// 违规通知整改
	informreport:state => {
		let unreview =state.informreport ? state.informreport.toreview||null :null;
		let qualified =state.informreport? state.informreport.qualified || null:null;
		let unqualified = state.informreport?state.informreport.unqualified || null:null;
		let xData=new Set()
		const getData = (obj) => {
			if(obj){
				let result=[]
				for(let key in obj){
					if(platformChineseFun(key)&&obj[key]>0){
						result.push(obj[key])
						xData.add(platformChineseFun(key))
					}
				}
				return result
			}
			else return []
		}

		let seriesData = {
			top:state.informreport.top || {},
			data:[{
				name:'未复查',
				data:getData(unreview)
			},{
				name:'复查合格',
				data:getData(qualified)
			},{
				name:'复查不合格',
				data:getData(unqualified)
			}],
			legend:['未复查','复查合格','复查不合格'],
			xData:[...xData],
		}
		console.log(xData)
		console.log(seriesData)
		return seriesData
	},
	// 知识产权投诉
	IPRCompliantData:state => {
		let intellectual = state.IPRCompliantData;
		let seriesData = [{
			name:'阿里',
			seriesData:[{
				name:'阿里',
				value:intellectual.tbcount,
				percentage:(intellectual.tbcount/intellectual.maincount*100).toFixed(2)
			}]
		},{
			name:'京东',
			seriesData:[{
				name:'京东',
				value:intellectual.jdcount,
				percentage:(intellectual.jdcount/intellectual.maincount*100).toFixed(2)
			}]
		  },{
			name:'苏宁',
			seriesData:[{
				name:'苏宁',
				value:intellectual.sncount,
				percentage:(intellectual.sncount/intellectual.maincount*100).toFixed(2)
			}]
		},{
			name:'拼多多',
			seriesData:[{
				name:'拼多多',
				value:intellectual.pddcount,
				percentage:(intellectual.pddcount/intellectual.maincount*100).toFixed(2)
			}]
		}]

		return seriesData
	}
}

const	mutations = {
	changeStep(state,payLoad){
		state.serviceStep = payLoad;
	},
	// 服务报告生成参数
	createQuery(state,payload){
		state.reportQuery = payload;
	},
	getServiceReportList(state,payload){
		state.serviceReportData = payload;
	},
	getServiceLowpriceList(state,payload){
		state.serviceLowpriceList = payload;
	},
	getServiceChart(state,payload){
		state.serviceChart = payload
		if(payload.dealerandshop){
			state.CInventoryData = JSON.parse(payload.dealerandshop)
		}
		if(payload.intellectual){
			console.log(payload.intellectual)
			state.IPRCompliantData = JSON.parse(payload.intellectual)
		}
		if(payload.informreport){
			state.informreport = JSON.parse(payload.informreport)
		}
		if(payload.everydaylowprice){
			let res = JSON.parse(payload.everydaylowprice)
			let maxPlateform = res.listData?getMaxPlat(res.listData).plateName:'--'
			let maxCount = res.listData?parseInt(getMaxPlat(res.listData).maxCount):'--'
			state.serviceLowpriceCount = {
				searchCount: parseInt(res.count),
		 		totalCount:parseInt(res.totalCount),
	 			maxPlateform:maxPlateform,
		 		maxCount:maxCount,
			}
			state.serviceLowpriceChart = res.listData || []
		}
	},
	getbmcwx(state,payLoad){
		state.userinfo = payLoad;
	},
	saveCheckCookCooks(state,payLoad){
		state.reportcheckCookCooks=payLoad
	}
}
const	actions = {
	// 查看绑定微信
	reqGetbmcwx({commit},params){
		return new Promise((r,j)=>{
			fetchGet('/hcm/userout/getbmcwx',params).then(res=>{
				commit('getbmcwx',res.data.data)
				r(res.data.data)
			}).catch(() => {
				j();
			})
		})
	},
  //报告列表
  reqServiceReportList({commit},params) {
	return new Promise((r,j)=>{
		fetchGet("/hcm/hcmChannelServiceReport/getchannelServiceReport",params).then((res) => {
			commit('getServiceReportList', res.data);
			r();
		}).catch(()=>{
			j();
		})
	})
  },
  //日常违规检索表格
  reqServiceLowpriceList({commit},params){
	return new Promise((r,j)=>{
		fetchGet("/hcm/wechat/dailyReportDate",params).then(res=>{
			commit('getServiceLowpriceList', res.data);
			r();
		}).catch(()=>{
			j();
		})
	})
  },
  //渠道信息盘点，违规通知整改，知识产权投诉,日常违规检索
  reqServiceChart({commit},params){
	return new Promise((r,j)=>{
		fetchGet("/hcm/wechat/getchannelServiceReportDetails",params).then(res=>{
			if(res.data){
				commit('getServiceChart', res.data);
			}
			r()
		}).catch(()=>{
			j()
		})
	})
	},
	// 服务报告预览建议
  reqServiceReportPreview({commit},params){
		return new Promise((r,j)=>{
			fetchGet("/hcm/hcmChannelServiceReport/channelServiceReport",params).then(res=>{
				commit('getServiceChart', res.data);
				r()
			}).catch(()=>{
				j()
			})
		})
		}
}

export default {
  state,
  getters,
  mutations,
  actions
}
